<template>
  <div class="uploadWrapper">
    <vuedraggable
      class="vue-draggable"
      :class="{ single: isSingle, maxHidden: isMaxHidden }"
      v-model="fileList"
      draggable=".draggable-item"
      @start="onDragStart"
      @end="onDragEnd">
      <!-- 拖拽元素 -->
      <div
        v-for="(item, index) in fileList"
        :key="item + index"
        class="draggable-item"
        :style="{ width: width + 'px', height: height + 'px' ,}">
        <img :src="item" :style="{ width: width + 'px', height: height + 'px' }"/>
        <div class="shadow" @click="onRemoveHandler(index)">
          <i class="icon-remove"></i>
        </div>
      </div>
      <!-- 上传按钮 -->
      <div class="upload-com">
<!--        <a-upload-->
<!--          name="file"-->
<!--          class="uploadBox"-->
<!--          :multiple="true"-->
<!--          list-type="picture-card"-->
<!--          @change="handleChange"-->
<!--          :loading="loading"-->
<!--          :before-upload="beforeUpload"-->
<!--          :customRequest="upload"-->
<!--          :file-list="[]">-->
<!--          <i class="el-icon-plus uploadIcon"></i>-->
<!--        </a-upload>-->
        <cropper-uploader
          :options="this.options"
          @change="handleChange"
          :onUploadSuccess="onUploadSuccess"
          :multi="true"
          avatarTextTop=""
          avatarTextBottom=""/>
      </div>
    </vuedraggable>
  </div>
</template>

<script>
import vuedraggable from 'vuedraggable';
import { _uploadImage, _uploadS3Image } from '@/api/uploadFileApi.js';
import CropperUploader from '@/components/CropperUploader.vue';

async function onUploadSuccess(e) {
  // const formData = new FormData();
  console.log(this.options.serviceType)
  console.log('multiUploader, data: ' + e)
  console.log('on Upload Success')
  this.$emit('input', [...this.value, e]);
  // formData.append('file', e.file);
  // const result = await _uploadS3Image(formData);
  // console.log(result)
  // if (result) {
  //   console.log('success upload S3')
  //   this.$emit('input', [...this.value, result]);
  //   console.log(...this.value)
  // }
  // } else {
  //   const result = await _uploadImage(formData);
  //   console.log(result)
  //   if (result) {
  //     this.$emit('input', [...this.value, result]);
  //     console.log(...this.value)
  //   }
}

export default {
  name: 'DraggableTest',
  props: {
    // 图片数据(图片url组成的数组) 通过v-model传递
    // 限制上传的图片数量
    value: {
      type: Array,
    },
    limit: {
      type: Number,
      default: 99
    },
    // 限制上传图片的文件大小(kb)
    size: {
      type: Number,
      default: 500
    },
    // 是否是单图上传(单图上传就是已传图片和上传按钮重叠)
    isSingle: {
      type: Boolean,
      default: false
    },
    // 是否使用图片压缩
    useCompress: {
      type: Boolean,
      default: false
    },
    // 图片显示的宽度(px)
    width: {
      type: Number,
      default: 100
    },
    // 图片显示的高度(px)
    height: {
      type: Number,
      default: 100
    },
    options: {
      type: Object,
      default: function () {
        return {
          autoCrop: true, // 是否默认生成截图框
          autoCropWidth: 1020, // 默认生成截图框宽度
          autoCropHeight: 480, // 默认生成截图框高度
          fixedBox: true, // 是否固定截图框大小 不允许改变
          previewsCircle: false, // 预览图是否是原圆形
          serviceType: '',
          multi: true,
          title: '修改图片',
        };
      },
    },
  },
  data() {
    return {
      fileList: [],
      imgList: [],
      isUploading: false, // 正在上传状态
      isFirstMount: true, // 控制防止重复回显,
      loading: false,
    };
  },
  computed: {
    isMaxHidden() {
      return this.imgList.length >= this.limit;
    }
  },
  created() {
    console.log(this.options.serviceType)
    console.log(this.options.multi)
    if (this.value) {
      this.fileList = this.value;
    }
  },
  watch: {
    value(val) {
      this.fileList = this.value;
      this.$emit('input', val);
    },
    fileList(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    onUploadSuccess,
    random_string(len) {
      // len = len || 32;
      const length = len || 32;
      const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678';
      const maxPos = chars.length;
      let pwd = '';
      for (let i = 0; i < length; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    handleChange({ file, fileList }) {
      this.loading = true;
      if (file.status === 'done') {
        this.loading = false;
        this.currentImgPath = file.response;
        this.$emit('input', [...this.value, file.response]);
      }
      if (file.status === 'removed') {
        this.files = fileList.map(x => x.url);
        this.loading = false;
        // this.$emit('input', fileList.map(x => x.url))
      }
    },
    // 上传图片之前
    beforeUpload(file) {
      // todo need to check
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('You can only upload JPG file!');
      }
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isLt20M) {
        this.$message.error('Image must smaller than 20MB!');
      }
      return isJpgOrPng && isLt20M;
    },
    // 移除单张图片
    onRemoveHandler(index) {
      this.$confirm({
        title: '确定删除该图片?',
        onOk: () => {
          this.fileList = this.fileList.filter((v, i) => {
            return i !== index;
          });
        }
      });
    },
    onDragStart(e) {
      e.target.classList.add('hideShadow');
    },
    onDragEnd(e) {
      e.target.classList.remove('hideShadow');
    }
  },
  components: { CropperUploader, vuedraggable }
};
</script>

<style lang="less" scoped>

// 上传按钮
.uploadIcon {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 20px;
  color: #999;

  .limitTxt,
  .uploading {
    position: absolute;
    bottom: 10%;
    left: 0;
    width: 100%;
    font-size: 14px;
    text-align: center;
  }
}

// 拖拽
.vue-draggable {
  display: flex;
  flex-wrap: wrap;

  .upload-com {
    display: inline-block;
  }

  .draggable-item {
    margin-right: 5px;
    margin-bottom: 5px;
    border: 1px solid #ddd;
    border-radius: 6px;
    position: relative;
    overflow: hidden;

    .img {
      width: 100%;
      height: 100%;
    }

    .shadow {
      position: absolute;
      top: 0;
      right: 0;
      background-color: rgba(0, 0, 0, .5);
      opacity: 0;
      transition: opacity .3s;
      color: #fff;
      font-size: 30px;
      line-height: 30px;
      padding: 5px;
      cursor: pointer;
    }

    &:hover {
      .shadow {
        opacity: 1;
      }
    }
  }

  &.hideShadow {
    .shadow {
      display: none;
    }
  }

  &.single {
    overflow: hidden;
    position: relative;

    .draggable-item {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
    }
  }

  &.maxHidden {
    .uploadBox {
      display: none;
    }
  }
}

.el-image-viewer__wrapper {
  .el-image-viewer__mask {
    opacity: .8;
  }

  .el-icon-circle-close {
    color: #fff;
  }
}
</style>
